let timer = null;
function debounce(fn,wait){
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
        fn(this,arguments)
    },wait)
}
export default debounce;